import { z } from 'zod';

import { defineQuery } from '@nesso/common-contracts/define';

export const GET_EMAIL_VERIFICATION_STATUS_TYPE = 'user/get-email-verification-status';

export const getEmailVerificationStatus = defineQuery(
    GET_EMAIL_VERIFICATION_STATUS_TYPE,
    z.object({
        email: z.email(),
    }),
    z.object({
        email: z.email(),
        verified: z.boolean(),
    }),
);
